// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.OperatorValue.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Filter Properties component
 */
import { observer } from 'mobx-react';
import React from 'react';
import Input from 'share/components/controls/Izenda.Input';
import OperatorValueDropdownGroup from 'modules/OperatorValue/Izenda.OperatorValueDropdownGroup';
import OperatorValueInput from 'modules/OperatorValue/Izenda.OperatorValueInput';
import OperatorValueDatetime from 'modules/OperatorValue/Izenda.OperatorValueDatetime';
import OperatorValueComparison from 'modules/OperatorValue/Izenda.OperatorValueComparison';
import OperatorValueEquivalence from 'modules/OperatorValue/Izenda.OperatorValueEquivalence';
import { OPERATOR, OPERATOR_GROUP } from 'logic/data/Izenda.FilterDetailsConfigConstants';
import { isNil, some, get } from 'lodash/fp';
import classnames from 'classnames';

/**
 * Get component render function
 * @param  {object} object Component object
 * @param  {string} key Operator filter key
 * @return {function} Render component function
 */
function getComponentRender(object: any, key: string) {
  return get(key, object);
}

/**
 * Operator group filter value
 * @type {Object}
 */
const filterValuesComponents = {
  fieldcomparison: {
    component: OperatorValueDropdownGroup,
    props: {
      labelField: 'sourceFieldName',
      valueField: 'querySourceFieldId',
      groupBy: 'sourceDataObjectName'
    }
  },
  'date&time': {
    component: OperatorValueDatetime
  },
  string: {
    component: OperatorValueInput
  },
  comparison: {
    component: OperatorValueComparison
  },
  boolean: {
    component: Input
  },
  equivalence: {
    component: OperatorValueEquivalence
  }
};

export default observer(function OperatorValue(props: any) {
  const { filterInfo, className } = props;
  const group = filterInfo.group || {};
  const operator = filterInfo.operator || {};
  const { key: groupKey } = group;
  const { key: operatorKey } = operator;

  const componentInfo = getComponentRender(filterValuesComponents, groupKey);

  function isValueRequired() {
    const groups = [OPERATOR_GROUP.BOOLEAN, OPERATOR_GROUP.UNKNOWN];

    const operators = [OPERATOR.BLANK, OPERATOR.NOTBLANK, OPERATOR.UNKNOWN, OPERATOR.NULL, OPERATOR.NOTNULL];

    return !some(g => g === groupKey, groups) && !some(o => o === operatorKey, operators);
  }

  const classes = classnames('u_marginTop izenda-OperatorValue', className);

  return (
    !isNil(componentInfo) &&
    isValueRequired() && (
      <div className={classes}>
        <componentInfo.component {...componentInfo.props} {...props} />
      </div>
    )
  );
});



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/Filter/Izenda.OperatorValue.js